// extracted by mini-css-extract-plugin
module.exports = {"roundedImage":"image_roundedImage__1_Ro0"};